import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import style from "./menu.module.scss";
import LogoImage from "../../../static/images/medline-logo.svg";
import WorkList from "../../../static/images/worklist-icon.svg";
import Patients from "../../../static/images/patients-icon.svg";
import Wound from "../../../static/images/wounds-icon.svg";
import Admin from "../../../static/images/admin-icon.svg";
import BIReports from "../../../static/images/BIReports.svg";
import TreatmentOutcomes from "../../../static/images/TreatmentOutcomes.svg";
import QualityAssurance from "../../../static/images/QualityAssurance.svg";
import CloseIcon from "../../../static/images/closeIcon.svg";
import Home from "../../../static/images/home_health.svg";
import { navigationChecker, primaryNavigationChecker, rbacMasterSecNavChecker } from "../../../utils/rbac";
import { closeMenu } from "../../../app/menuSlice";

export const Menu = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const origin = window.location.origin;
  const currentPath = `${origin}${location.pathname}`;
  const userRole = useSelector((state) => state.user);

  const [showAdminMenu, setShowAdminMenu] = useState(false);

  useEffect(() => {
    dispatch(closeMenu());
    setShowAdminMenu(false);
  }, [dispatch, location.pathname]);

  const isActive = (...segments) => segments.some((seg) => currentPath.includes(`${origin}/${seg}`));
  const homeActive = currentPath === `${origin}/`;

  // const wmsDisabled = userRole?.role !== "MedlineAdministrator" && userRole?.customerSettings?.ne1Wms === 0;

  // const wmsLink = (target) => (wmsDisabled ? "/learnMore" : target);

  const handleNav = () => {
    setShowAdminMenu(false);
  };

  return (
    <div>
      <div className={style.left_menu}>
        <div className="container-fluid m-0">
          <div className="row">
            <div className={`${style.left_bg}`}>
              <div className={`animate ${style.first_left_menu} ${style.fade_in_left_move}`}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className={style.LogoImage_Second_slide}>
                    <img src={LogoImage} alt="Logo" className="img-fluid" />
                  </div>
                  <div
                    className={style.CloseIcon_Second_slide}
                    onClick={() => {
                      dispatch(closeMenu());
                      setShowAdminMenu(false);
                    }}
                  >
                    <img src={CloseIcon} alt="Close menu" className="img-fluid" />
                  </div>
                </div>

                <div className={`${style.main_list_icon}`}>
                  <ul>
                  <li className={style.admin_icon}>
                      <Link id="home" to={"/"} className={homeActive ? style.active : ""} onClick={handleNav}>
                        <img src={Home} alt="icon" />
                        <span className={style.admin_menu_text}>Home</span>
                      </Link>
                    </li>
                    {primaryNavigationChecker("primaryNavWorklist", userRole.role) && <li className={style.admin_icon}>
                      <Link id="work_list" to={"/worklist"} className={isActive("worklist") ? style.active : ""} onClick={handleNav}>
                        <img src={WorkList} alt="icon" />
                        <span className={style.admin_menu_text}>Work List</span>
                      </Link>
                    </li>}
                    <li className={style.admin_icon}>
                      <Link id="patients" to={"/patients"} className={isActive("patients") ? style.active : ""} onClick={handleNav}>
                        <img src={Patients} alt="icon" />
                        <span className={style.admin_menu_text}>Patients</span>
                      </Link>
                    </li>
                    <li className={style.admin_icon}>
                      <Link
                        id="wounds"
                        to={"/woundReport"}
                        className={currentPath === `${origin}/woundReport` ? style.active : ""}
                        onClick={handleNav}
                      >
                        <img src={Wound} alt="icon" />
                        <span className={style.admin_menu_text}>Wounds</span>
                      </Link>
                    </li>
                    <li className={style.admin_icon}>
                      <Link
                        id="treatment_outcomes"
                        to={"/treatmentReport"}
                        className={currentPath === `${origin}/treatmentReport` ? style.active : ""}
                        onClick={handleNav}
                      >
                        <img src={TreatmentOutcomes} alt="icon" />
                        <span className={style.admin_menu_text}>Treatment Outcomes</span>
                      </Link>
                    </li>
                    <li className={style.admin_icon}>
                      <Link
                        id="quality_assurance"
                        to={"/qualityReport"}
                        className={currentPath === `${origin}/qualityReport` ? style.active : ""}
                        onClick={handleNav}
                      >
                        <img src={QualityAssurance} alt="icon" />
                        <span className={style.admin_menu_text}>Quality Assurance</span>
                      </Link>
                    </li>
                    <li className={style.admin_icon}>
                      <Link
                        id="ad_hoc_reports"
                        to={"/biReports"}
                        className={currentPath === `${origin}/biReports` ? style.active : ""}
                        onClick={handleNav}
                      >
                        <img src={BIReports} alt="icon" />
                        <span className={style.admin_menu_text}>Ad-hoc Reports</span>
                      </Link>
                    </li>
                  </ul>
                </div>

                {primaryNavigationChecker("primaryNavAdmin", userRole.role) && (
                  <div
                    className={`${style.admin_icon} ${style.main_list_icon_admin}`}
                    onMouseEnter={() => setShowAdminMenu(true)}
                    onMouseLeave={() => setShowAdminMenu(false)}
                  >
                    <Link to="/worklist" className={isActive("admin", "platformanalytics") ? style.active : ""} onClick={handleNav}>
                      <img src={Admin} alt="icon" />
                      <span className={style.admin_menu_text}>Admin</span>
                      <span className="ml-auto pr-3">
                        <i className="fa fa-chevron-right" style={{ color: "#002d72", fontSize: "12px" }} aria-hidden="true" />
                      </span>
                    </Link>

                    <div
                      data-testid="admin-menu"
                      className={`${style.left_admin_bg} ${showAdminMenu ? style.left_admin_bg_active : ""}`}
                      onMouseEnter={() => setShowAdminMenu(true)}
                      onMouseLeave={() => setShowAdminMenu(false)}
                    >
                      <div className={style.admin_submenu}>
                        <div className={style.admin_menu}>
                          <p className={style.admin_menu_hdg}>Dashboard</p>
                          <hr className={`${style.horizontalRow} text-left`} />
                          <ul className={style.admin_menu_list}>
                            {navigationChecker("navPlatformAnalytics", userRole.role) && (
                              <li>
                                <Link
                                  to="/platformanalytics"
                                  className={currentPath === `${origin}/platformanalytics` ? style.active : ""}
                                  onClick={handleNav}
                                >
                                  Platform Analytics
                                </Link>
                              </li>
                            )}
                            {userRole.role === "ExternalAdministrator" && (
                              <li>
                                <Link to="/admin/customers" className={isActive("admin/customers") ? style.active : ""} onClick={handleNav}>
                                  Company Profile
                                </Link>
                              </li>
                            )}
                            {navigationChecker("navUsageAnalytics", userRole.role) && (
                              <li>
                                <Link
                                  to="/admin/usageAnalytics"
                                  className={currentPath === `${origin}/admin/usageAnalytics` ? style.active : ""}
                                  onClick={handleNav}
                                >
                                  Usage Analytics
                                </Link>
                              </li>
                            )}
                            {navigationChecker("navSurveyResult", userRole.role) && (
                              <li>
                                <Link
                                  to="/admin/surveyResult"
                                  className={currentPath === `${origin}/admin/surveyResult` ? style.active : ""}
                                  onClick={handleNav}
                                >
                                  Survey Results
                                </Link>
                              </li>
                            )}
                            {navigationChecker("navFormBuilder", userRole.role) && (
                              <li>
                                <Link to="/admin/formBuilder" className={isActive("admin/formBuilder") ? style.active : ""} onClick={handleNav}>
                                  Form Builder
                                </Link>
                              </li>
                            )}
                            {navigationChecker("navContextualSupport", userRole.role) && (
                              <li>
                                <Link to="/admin/support" className={isActive("admin/support") ? style.active : ""} onClick={handleNav}>
                                  Contextual support
                                </Link>
                              </li>
                            )}
                            {navigationChecker("navInAppMessaging", userRole.role) && (
                              <li>
                                <Link to="/admin/announcement" className={isActive("admin/announcement") ? style.active : ""} onClick={handleNav}>
                                  In-App Messaging
                                </Link>
                              </li>
                            )}
                          </ul>
                        </div>

                        <div className={style.admin_menu}>
                          {rbacMasterSecNavChecker("navMaster", userRole.role) && (
                            <>
                              <p className={style.admin_menu_hdg}>Master Data</p>
                              <hr className={`${style.horizontalRow} text-left`} />
                              <ul className={style.admin_menu_list}>
                                {navigationChecker("navProducts", userRole.role) && (
                                  <li>
                                    <Link to="/admin/products" className={isActive("admin/products") ? style.active : ""} onClick={handleNav}>
                                      Products
                                    </Link>
                                  </li>
                                )}
                                {navigationChecker("navCustomers", userRole.role) && (
                                  <li>
                                    <Link to="/admin/customers" className={isActive("admin/customers") ? style.active : ""} onClick={handleNav}>
                                      Customers
                                    </Link>
                                  </li>
                                )}
                                {navigationChecker("navFormulary", userRole.role) && (
                                  <li>
                                    <Link to="/admin/formulary" className={isActive("admin/formulary") ? style.active : ""} onClick={handleNav}>
                                      Formulary
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </>
                          )}

                          {navigationChecker("navUsers", userRole.role) && (
                            <div className={style.admin_menu}>
                              <p className={style.admin_menu_hdg}>Users</p>
                              <hr className={`${style.horizontalRow} text-left`} />
                              <ul className={style.admin_menu_list}>
                                <li>
                                  <Link to="/admin/users" className={isActive("admin/users") ? style.active : ""} onClick={handleNav}>
                                    Manage Users
                                  </Link>
                                </li>
                                {userRole.role === "MedlineAdministrator" && (
                                  <li>
                                    <Link to="/admin/sso" className={isActive("admin/sso") ? style.active : ""} onClick={handleNav}>
                                      SSO
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>

                        <div className={style.admin_menu}>
                          {navigationChecker("navMobolileAppMngmnt", userRole.role) && (
                            <div className={style.admin_menu}>
                              <p className={style.admin_menu_hdg}>Mobile App Mngmt</p>
                              <hr className={`${style.horizontalRow} text-left`} />
                              <ul className={style.admin_menu_list}>
                                <li>
                                  <Link to="/admin/layouts" className={isActive("admin/layouts") ? style.active : ""} onClick={handleNav}>
                                    Layout
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          )}

                          {navigationChecker("navNE1WMS", userRole.role) && (
                            <div className={style.admin_menu}>
                              <p className={style.admin_menu_hdg}>NE1 WMS</p>
                              <hr className={`${style.horizontalRow} text-left`} />
                              <ul className={style.admin_menu_list}>
                                <li>
                                  <Link
                                    id="patient_management"
                                    to={
                                      userRole?.role !== "MedlineAdministrator" && userRole?.customerSettings?.ne1Wms === 0
                                        ? "/learnMore"
                                        : "/admin/patients"
                                    }
                                    className={isActive("admin/patients") ? style.active : ""}
                                    onClick={() => {
                                      handleNav();
                                      window.scrollTo(0, 0);
                                    }}
                                  >
                                    Patient Management
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
